import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend, { HttpBackendOptions } from "i18next-http-backend";
// import resourcesToBackend from "i18next-resources-to-backend";

// Import translations
import enTranslation from "./locales/en.json";
import frTranslation from "./locales/fr.json";
import apiClient from "../api/api-client";

// Initialize i18next
i18n
	.use(LanguageDetector)
	.use(HttpBackend)
	.use(initReactI18next)
	.init<HttpBackendOptions>({
		backend: {
			loadPath: `${process.env.REACT_APP_API_URL}/referential-translations?languageCode={{lng}}`,
			request: (_options, url, _payload, callback) => {
				// Use axios so it goes through your interceptors
				apiClient
					.get(url)
					.then(response => {
						callback(null, {
							status: response.status,
							data: response.data
						});
					})
					.catch(error => {
						callback(error, error.response);
					});
			}
		},
		initImmediate: false,
		supportedLngs: ["fr", "en"],
		fallbackLng: ["fr", "en"],
		debug: process.env.NODE_ENV === "development",
		interpolation: {
			escapeValue: false // React already escapes by default
		},
		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"]
		}
	});

i18n.addResourceBundle("en", "", enTranslation, false, true);
i18n.addResourceBundle("fr", "", frTranslation, false, true);

i18n.on("loaded", loaded => {
	Object.keys(loaded).forEach(lng => {
		Object.keys(loaded[lng]).forEach(ns => {
			const httpTranslations = loaded[lng];
			const localTranslations =
				{
					en: enTranslation,
					fr: frTranslation
				}[lng] || {};

			// Merge: HTTP translations override local ones
			const merged = { ...localTranslations, ...httpTranslations };

			// Update the resource bundle with merged data
			i18n.addResourceBundle(lng, ns, merged, true, true);
		});
	});
});

export default i18n;
